// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lobby.css */
.gator-image-container {
  background-color: #272727;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
}

.gator-lobby-image {
  max-width: calc(100vw);
  width: calc(60vh);
  /* max-width: calc(60vh); */
  height: auto;
}

.lobby-menu {
  position: fixed;
  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */
  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */

  top: var(--custom-top, calc(calc(47vh)));
  left: 50%;
  transform: translate(-50%, 0%);
  max-width: calc(75vh);
  width: 92%;
  text-align: center;
  background-color: #272727;
  opacity: 0.9;
  padding: 3px;
  border-radius: 12px;
  z-index: 1101;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.lobby-menu {
  scrollbar-width: thin;
  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);
}

.lobby-menu,
.lobby-menu * {
  touch-action: pan-y;
}

.lobby-menu::-webkit-scrollbar {
  display: block;
  width: 8px;
}

.lobby-menu::-webkit-scrollbar-track {
  background: var(--tg-theme-bg-color);
}

.lobby-menu::-webkit-scrollbar-thumb {
  background-color: var(--tg-theme-hint-color);
  border-radius: 4px;
}

/* Titles and Text */
.lobby-menu-title {
  font-size: 33px;
  font-weight: bold;
  margin-bottom: 0px;
  text-align: center;
  color: var(--tg-theme-button-color); 
}

.lobby-item {
  margin: 5px;
  padding: 5px 8px;
  background-color: var(--tg-theme-secondary-bg-color);
  border-radius: 12px;
}

.lobby-info {
  margin-bottom: 2px;
}

.lobby-name {
  font-size: 20px;
  font-weight: bold;
  color: var(--tg-theme-text-color);
  text-align: left;
}

.lobby-description {
  font-size: 17px;
  color: var(--tg-theme-text-color);
  padding: 3px;
  margin-top: 2px;
  margin-bottom: 0px;
  text-align: left;
}

.feature-info {
  margin-bottom: 10px;
}

.feature-name {
  font-size: 22px;
  font-weight: bold;
  color: var(--tg-theme-text-color);
}

.feature-description {
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 0px;
  margin-top: 7px;
  margin-bottom: 0px;
}

.lobby-small-button, .lobby-wide-button, .lobby-gray-button {
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);

  font-size: 18px;

  border: none;
  padding: 12px;
  border-radius: 12px;
  margin: 1%;
  margin-bottom: 1.5%;

  cursor: pointer;
}

.lobby-small-button {
  width: 48%;
}

.lobby-wide-button {
  width: 98%;
}

`, "",{"version":3,"sources":["webpack://./src/components/lobby/Lobby.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,6CAA6C;EAC/D,gBAAgB,EAAE,uDAAuD;;EAEzE,wCAAwC;EACxC,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;;EAExC,eAAe;;EAEf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Lobby.css */\r\n.gator-image-container {\r\n  background-color: #272727;\r\n  position: fixed;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.gator-lobby-image {\r\n  max-width: calc(100vw);\r\n  width: calc(60vh);\r\n  /* max-width: calc(60vh); */\r\n  height: auto;\r\n}\r\n\r\n.lobby-menu {\r\n  position: fixed;\r\n  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */\r\n  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */\r\n\r\n  top: var(--custom-top, calc(calc(47vh)));\r\n  left: 50%;\r\n  transform: translate(-50%, 0%);\r\n  max-width: calc(75vh);\r\n  width: 92%;\r\n  text-align: center;\r\n  background-color: #272727;\r\n  opacity: 0.9;\r\n  padding: 3px;\r\n  border-radius: 12px;\r\n  z-index: 1101;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.lobby-menu {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);\r\n}\r\n\r\n.lobby-menu,\r\n.lobby-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.lobby-menu::-webkit-scrollbar {\r\n  display: block;\r\n  width: 8px;\r\n}\r\n\r\n.lobby-menu::-webkit-scrollbar-track {\r\n  background: var(--tg-theme-bg-color);\r\n}\r\n\r\n.lobby-menu::-webkit-scrollbar-thumb {\r\n  background-color: var(--tg-theme-hint-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Titles and Text */\r\n.lobby-menu-title {\r\n  font-size: 33px;\r\n  font-weight: bold;\r\n  margin-bottom: 0px;\r\n  text-align: center;\r\n  color: var(--tg-theme-button-color); \r\n}\r\n\r\n.lobby-item {\r\n  margin: 5px;\r\n  padding: 5px 8px;\r\n  background-color: var(--tg-theme-secondary-bg-color);\r\n  border-radius: 12px;\r\n}\r\n\r\n.lobby-info {\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.lobby-name {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: var(--tg-theme-text-color);\r\n  text-align: left;\r\n}\r\n\r\n.lobby-description {\r\n  font-size: 17px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 3px;\r\n  margin-top: 2px;\r\n  margin-bottom: 0px;\r\n  text-align: left;\r\n}\r\n\r\n.feature-info {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.feature-name {\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  color: var(--tg-theme-text-color);\r\n}\r\n\r\n.feature-description {\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 0px;\r\n  margin-top: 7px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.lobby-small-button, .lobby-wide-button, .lobby-gray-button {\r\n  background-color: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n\r\n  font-size: 18px;\r\n\r\n  border: none;\r\n  padding: 12px;\r\n  border-radius: 12px;\r\n  margin: 1%;\r\n  margin-bottom: 1.5%;\r\n\r\n  cursor: pointer;\r\n}\r\n\r\n.lobby-small-button {\r\n  width: 48%;\r\n}\r\n\r\n.lobby-wide-button {\r\n  width: 98%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
